module.exports = __webpack_public_path__ + "assets/img/100302.5e293841.svg";